import React, { useContext, useEffect, useRef, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import CustomBreadcrumb from "../../common/CustomBreadcrumb";
import { pathName } from "../../utils/commonUtils";
import { BreadCrum } from "../../common";
// import { getNotificationsListsHandler } from "../../redux/action/getNotificationsListSlice";
import { useDispatch, useSelector } from "react-redux";
import CommonTable from "../../common/CommonTable";
import { ThemeContext } from "../../common/themeContext";
import Loader from "../../components/Loder/loader";
// import { notificationColumns } from "../Notification/notificationUtils";
import { welcomeEmailListHandler } from "../../redux/action/welcomeEmailList";
import { emailColumns } from "./emailColumns";
import moment from "moment";
import { SearchSelect } from "../../common/SearchSelect";
import { useFormik } from "formik";
import { getItem } from "../../common/localStorage";
import { productListDropdownHandler } from "../../redux/action/productListDropdownAPI";
import { groupListDropdownHandler } from "../../redux/action/groupListDropdownAPI";
import { userListDropdownHandler } from "../../redux/action/userListDropdownAPI";
import { triggerWelcomeEmailAction, triggerWelcomeEmailHandler } from "../../redux/action/triggerWelcomeEmail";
import { getProductHandler } from "../../redux/action/getAllProductSlice";
import SwitchModal from "./SwitchModal";
import { CommanSearchBox } from "../../common/commanSearchBox";
import { useCommonMessage } from "../../common/CommonMessage";
import { welcomeEmailTemplateListHandler } from "../../redux/action/welcomeEmailTemplateList";
import { updateEmailTemplateAction, updateEmailTemplateHandler } from "../../redux/action/updateEmailTemplate";
const EmailTemplatesList = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [emailListData, setEmailListData] = useState([]);
  // State for switch modal and which row is being toggled
  const [switchModalOpen, setSwitchModalOpen] = useState(false);
  const [switchRowKey, setSwitchRowKey] = useState(null);
  const [switchStates, setSwitchStates] = useState({}); // {rowKey: true/false}
  const [pendingUpdatePayload, setPendingUpdatePayload] = useState(null);
  const [warningModalOpen, setWarningModalOpen] = useState(false);
  const [warningMessage, setWarningMessage] = useState("");
  const [warningTitle, setWarningTitle] = useState("");


  

  // Handler for switch toggle in table
  const updateEmailTemplateSelector = useSelector((state) =>state?.updateEmailTemplate)
  const handleSwitchToggle = (row, checked) => {
    const rowKey = row.id;
    if (checked) {
      setSwitchRowKey(rowKey);
      setSwitchModalOpen(true);
      const item = emailListData.find((item) => item.id === rowKey);
      let payload = {
        id: rowKey,
        enabled: true,
        templateName: item?.templateName,
        emailBody: item?.emailBody,
        emailBodySpanish: item?.emailBodySpanish,
        emailSubject: item?.emailSubject,
        emailSubjectSpanish: item?.emailSubjectSpanish,
        eventType: item?.eventType,
        date: moment(item?.modifiedAt).format("MM/DD/YYYY"),
        code: item?.code || "-",
      };
      setPendingUpdatePayload(payload);
    } else {
      // User is trying to turn off a switch
      const currentlyEnabledSwitches = Object.values(switchStates).filter(Boolean).length;
      if (currentlyEnabledSwitches === 1 && switchStates[rowKey]) {
        // This is the only enabled switch, prevent disabling it
        setWarningTitle("Action Blocked");
        setWarningMessage("At least one email template must remain active.");
        setWarningModalOpen(true);
      } else {
        setSwitchStates((prev) => {
          const next = { ...prev };
          delete next[rowKey];
          return next;
        });
        // No API call needed here, as the modal will handle it on 'Yes'
      }
    }
  };

  // Handler for modal response
  const handleSwitchModalYes = () => {
    // Ensure only one switch is ON at a time
    setSwitchStates({ [switchRowKey]: true });
    if (pendingUpdatePayload) {
      dispatch(updateEmailTemplateHandler(pendingUpdatePayload));
    }
    setPendingUpdatePayload(null);
    setSwitchModalOpen(false);
    setSwitchRowKey(null);
    dispatch(updateEmailTemplateAction.updateEmailTemplateReset());
    
  };
  
  const handleSwitchModalNo = () => {
    setSwitchStates((prev) => ({ ...prev, [switchRowKey]: false }));
    setSwitchModalOpen(false);
    setSwitchRowKey(null);
    dispatch(updateEmailTemplateAction.updateEmailTemplateReset());
  };

  const handleWarningModalOkay = () => {
    setWarningModalOpen(false);
    setSwitchRowKey(null);
  };
  
  // Show success/error after update API finishes
  useEffect(() => {
    if (updateEmailTemplateSelector?.message) {
      messageApi.open({ type: "error", content: updateEmailTemplateSelector?.message });
      dispatch(updateEmailTemplateAction.updateEmailTemplateReset());
    } else if (updateEmailTemplateSelector?.data?.statusCode === 200) {
      window.scrollTo(0, 0);
      messageApi.open({ type: "success", content: updateEmailTemplateSelector?.data?.message || "Template updated successfully" });
      dispatch(updateEmailTemplateAction.updateEmailTemplateReset());
    }
  }, [updateEmailTemplateSelector]);
  const messageApi = useCommonMessage();
  // Pass switch state and handler to columns
  const emailColumnsData = emailColumns(navigate, handleSwitchToggle, switchStates);
  const getAllProductList = useSelector((state) => state?.productListDropdown);
  const getAllGroupsList = useSelector((state) => state?.groupListDropdown);
  const getUserList = useSelector((state) => state?.userListDropdown);
  const triggerWelcomeSelector = useSelector((state) => state?.triggerWelcome);
  const [searchValue, setSearchValue] = useState("");

  useEffect(() => {
    if (triggerWelcomeSelector?.message) {
      messageApi.open({
        type: "error",
        content: triggerWelcomeSelector?.message,
      });
      dispatch(triggerWelcomeEmailAction.triggerWelcomeReset());
    } else if (triggerWelcomeSelector?.data?.statusCode === 200) {
      messageApi.open({
        type: "success",
        content: triggerWelcomeSelector?.data?.message,
      });
      dispatch(triggerWelcomeEmailAction.triggerWelcomeReset());
     
      navigate("/email-templates");
    }
  }, [triggerWelcomeSelector]);

  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 5,
    total: 100,
    showSizeChanger: true,
    pageSizeOptions: [5, 10, 15, 20],
    className: "order-pagination",
    locale: { items_per_page: "" },
    showTotal: (total, range) => `${range[0]}-${range[1]} of ${total}`,
  });

  const getWelcomeEmailListSelector = useSelector(
    (state) => state?.welcomeEmailTemplateList
  );
  const { brandId } = useContext(ThemeContext);

  useEffect(() => {
    if (getWelcomeEmailListSelector?.data?.statusCode === 200) {
      const getEmailData = getWelcomeEmailListSelector?.data?.data?.map(
        (item) => {
          let triggerLevel = "";
          if (item?.notificationReceiver?.groupId?.length > 0) {
            triggerLevel = "Group";
          } else if (item?.notificationReceiver?.userId?.length > 0) {
            triggerLevel = "Member";
          } else if (item?.notificationReceiver?.productId?.length > 0) {
            triggerLevel = "Product";
          }

            return {
            id: item?.id,
            templateName: item?.templateName,
            emailBody: item?.emailBody,
            emailBodySpanish: item?.emailBodySpanish,
            emailSubject: item?.emailSubject,
            emailSubjectSpanish: item?.emailSubjectSpanish,
            eventType: item?.eventType,
            createdAt: item?.createdAt,
            modifiedAt: item?.modifiedAt,
            date: moment(item?.modifiedAt).format("MM/DD/YYYY"),
            code: item?.code || "-",
            enabled: item?.enabled === true,
            triggerLevel,
          };
        }
      );
      setEmailListData(getEmailData);
      // Initialize switches: turn ON the one that is enabled
      const enabledRow = getEmailData.find((row) => row.enabled);
      if (enabledRow?.id) {
        setSwitchStates({ [enabledRow.id]: true });
      } else {
        setSwitchStates({});
      }
      setPagination((prevPagination) => ({
        ...prevPagination,
        total: getWelcomeEmailListSelector?.data?.totalElements,
        current: getWelcomeEmailListSelector?.data?.pageNumber,
        pageSize: getWelcomeEmailListSelector?.data?.pageSize,
      }));
    }else{
      // window.alert(getWelcomeEmailListSelector?.message)
    }
  }, [getWelcomeEmailListSelector]);

  let templateType = "";
  const handleTemplateListData = (offSet = 1, limit = 10,searchString = searchValue) => {
    if (brandId === 1) {
      templateType = "WELCOME_HC";
    } else if (brandId === 2) {
      templateType = "WELCOME_PC";
    }
    const payload = {
      offSet,
      limit,
      // brandId: brandId,
      eventType: templateType,
      searchString
    };
   
    // if (brandId === 1 || brandId === 2) {
      if (searchString) payload.searchString = searchString;
      dispatch(welcomeEmailTemplateListHandler(payload));
    // }
  };

  useEffect(() => {
    handleTemplateListData();
  }, [brandId,updateEmailTemplateSelector]);
  const [getProduct, setGetProduct] = useState([]);
  const [groupsData, setGroupsData] = useState([]);
  const [userData, setUserData] = useState([]);
  // Add pagination states
  const [productPage, setProductPage] = useState(1);
  const [productLoading, setProductLoading] = useState(false);
  const [hasMoreProducts, setHasMoreProducts] = useState(true);
  const PRODUCTS_PER_PAGE = 100;
  const INITIAL_PRODUCTS = 100;

  // Add group pagination states
  const [groupPage, setGroupPage] = useState(1);
  const [groupLoading, setGroupLoading] = useState(false);
  const [hasMoreGroups, setHasMoreGroups] = useState(true);
  const GROUPS_PER_PAGE = 100;
  const INITIAL_GROUPS = 100;

  // Add member pagination states
  const [memberPage, setMemberPage] = useState(1);
  const [memberLoading, setMemberLoading] = useState(false);
  const [hasMoreMembers, setHasMoreMembers] = useState(true);
  const MEMBERS_PER_PAGE = 100;
  const INITIAL_MEMBERS = 100;

  const storedTheme = getItem("theme");
  const { state } = useLocation();
  const [deleteUploadedFile, setDeleteUploadedFile] = useState("");
  useEffect(() => {
    handleProduct();
    handleGroup();
    handleMemberName()
  },[])
  useEffect(() => {
    if (getAllProductList?.data?.data) {
      const productData = getAllProductList?.data?.data?.map((item) => ({
        productId: item?.id,
        productName: item?.name,
        code: item?.code,
        productStatus: item?.activeStatus,
      }));

      if (productPage === 1) {
        setGetProduct(productData);
      } else {
        setGetProduct((prev) => {
          const existingIds = new Set(prev.map((p) => p.productId));
          const newProducts = productData.filter(
            (p) => !existingIds.has(p.productId)
          );
          return [...prev, ...newProducts];
        });
      }

      // Update hasMoreProducts based on the response length
      const receivedItems = productData.length;
      const expectedItems =
        productPage === 1 ? INITIAL_PRODUCTS : PRODUCTS_PER_PAGE;
      setHasMoreProducts(receivedItems >= expectedItems);
      setProductLoading(false);
    }

    if (getAllGroupsList?.data?.data) {
      const data = getAllGroupsList?.data?.data?.map((item) => {
        return {
          groupCode: item?.id,
          groupName: item?.name,
          caspioEmployerGroupCode: item?.group_Code,
        };
      });

      if (groupPage === 1) {
        setGroupsData(data);
      } else {
        setGroupsData((prev) => {
          const existingIds = new Set(prev.map((g) => g.groupCode));
          const newGroups = data.filter((g) => !existingIds.has(g.groupCode));
          return [...prev, ...newGroups];
        });
      }

      // Update hasMoreGroups based on the response length
      const receivedItems = data.length;
      const expectedItems = groupPage === 1 ? INITIAL_GROUPS : GROUPS_PER_PAGE;
      setHasMoreGroups(receivedItems >= expectedItems);
      setGroupLoading(false);
    }

    if (getUserList?.data?.data) {
      const getUser = getUserList?.data?.data.map((item) => {
        return {
          firstName: item?.firstName,
          lastName: item?.lastName,
          userId: item?.id,
          caspioUserId: item?.caspioUserId,
          memberStatus: item?.activeStatus,
        };
      });

      if (memberPage === 1) {
        setUserData(getUser);
      } else {
        setUserData((prev) => {
          const existingIds = new Set(prev.map((u) => u.userId));
          const newUsers = getUser.filter((u) => !existingIds.has(u.userId));
          return [...prev, ...newUsers];
        });
      }

      // Update hasMoreMembers based on the response length
      const receivedItems = getUser.length;
      const expectedItems =
        memberPage === 1 ? INITIAL_MEMBERS : MEMBERS_PER_PAGE;
      setHasMoreMembers(receivedItems >= expectedItems);
      setMemberLoading(false);
    }
  }, [
    getAllProductList,
    getAllGroupsList,
    getUserList,
    productPage,
    groupPage,
    memberPage,
  ]);
  const handleProduct = (searchString = "") => {
    const payload = {
      offSet: 1,
      limit: INITIAL_PRODUCTS,
      refBrandId: storedTheme === "healthCare" ? 1 : 2,
      searchString: searchString,
    };
    dispatch(productListDropdownHandler(payload));
  };

  const loadMoreProducts = () => {
    if (productLoading || !hasMoreProducts) return;

    setProductLoading(true);
    const nextPage = productPage + 1;
    const payload = {
      offSet: nextPage,
      limit: PRODUCTS_PER_PAGE,
      refBrandId: storedTheme === "healthCare" ? 1 : 2,
    };

    dispatch(productListDropdownHandler(payload));
    setProductPage(nextPage);
  };

  const loadMoreGroups = (searchString = "") => {
    if (groupLoading || !hasMoreGroups) return;

    setGroupLoading(true);
    const nextPage = groupPage + 1;
    const payload = {
      offSet: nextPage,
      limit: GROUPS_PER_PAGE,
      refBrandId: storedTheme === "healthCare" ? 1 : 2,
      searchString: searchString,
    };

    dispatch(groupListDropdownHandler(payload));
    setGroupPage(nextPage);
  };

  const loadMoreMembers = (searchString = "") => {
    if (memberLoading || !hasMoreMembers) return;

    setMemberLoading(true);
    const nextPage = memberPage + 1;
    const payload = {
      offSet: nextPage,
      limit: MEMBERS_PER_PAGE,
      refBrandId: storedTheme === "healthCare" ? 1 : 2,
      searchString: searchString,
    };

    dispatch(userListDropdownHandler(payload));
    setMemberPage(nextPage);
  };

  const handleGroup = (searchString = "") => {
    const payload = {
      offSet: 1,
      limit: INITIAL_GROUPS,
      refBrandId: storedTheme === "healthCare" ? 1 : 2,
      searchString: searchString,
    };
    dispatch(groupListDropdownHandler(payload));
  };

  const handleMemberName = (searchString = "") => {
    const payload = {
      offSet: 1,
      limit: INITIAL_MEMBERS,
      refBrandId: storedTheme === "healthCare" ? 1 : 2,
      searchString: searchString,
    };
    dispatch(userListDropdownHandler(payload));
  };

  const searchTimeoutRef = useRef(null);
  const handleMemberSearch = (value) => {
    if (searchTimeoutRef.current) {
      clearTimeout(searchTimeoutRef.current);
    }

    searchTimeoutRef.current = setTimeout(() => {
      handleMemberName(value);
    }, 1000);
  };

  const searchTimeoutGroupRef = useRef(null);
  const handleGroupSearch = (value) => {
    if (searchTimeoutGroupRef.current) {
      clearTimeout(searchTimeoutGroupRef.current);
    }

    searchTimeoutGroupRef.current = setTimeout(() => {
      handleGroup(value);
    }, 1000);
  };

  const searchTimeoutProductRef = useRef(null);
  const handleProductSearch = (value) => {
    if (searchTimeoutProductRef.current) {
      clearTimeout(searchTimeoutProductRef.current);
    }

    searchTimeoutProductRef.current = setTimeout(() => {
      handleProduct(value);
    }, 1000);
  };

  const throttleRef = useRef(false);
  const createInfiniteScrollHandler = (
    loaderFn,
    loadingRef,
    hasMoreRef,
    delay = 500
  ) => {
    return (e) => {
      const { scrollTop, scrollHeight, clientHeight } = e.target;
      const scrollPercentage = (scrollTop + clientHeight) / scrollHeight;

      if (
        scrollPercentage >= 0.8 &&
        !loadingRef.current &&
        hasMoreRef.current &&
        !throttleRef.current
      ) {
        throttleRef.current = true;
        loaderFn();

        setTimeout(() => {
          throttleRef.current = false;
        }, delay);
      }
    };
  };

  const groupLoadingRef = useRef(groupLoading);
  const hasMoreGroupsRef = useRef(hasMoreGroups);
  const productLoadingRef = useRef(productLoading);
  const hasMoreProductsRef = useRef(hasMoreProducts);

  const memberLoadingRef = useRef(memberLoading);
  const hasMoreMemberRef = useRef(hasMoreMembers);

  // Keep these refs in sync with latest values
  useEffect(() => {
    groupLoadingRef.current = groupLoading;
    hasMoreGroupsRef.current = hasMoreGroups;
    productLoadingRef.current = productLoading;
    hasMoreProductsRef.current = hasMoreProducts;
    memberLoadingRef.current = memberLoading;
    hasMoreMemberRef.current = hasMoreMembers;
  }, [
    groupLoading,
    hasMoreGroups,
    productLoading,
    hasMoreProducts,
    memberLoading,
    hasMoreMembers,
  ]);
 

  const handleGroupScroll = createInfiniteScrollHandler(
    loadMoreGroups,
    groupLoadingRef,
    hasMoreGroupsRef
  );
  const handleProductScroll = createInfiniteScrollHandler(
    loadMoreProducts,
    productLoadingRef,
    hasMoreProductsRef
  );
  const handleMemberScroll = createInfiniteScrollHandler(
    loadMoreMembers,
    memberLoadingRef,
    hasMoreMemberRef
  );

  const formik = useFormik({
    initialValues: {
      productName: "",
      groupName: "",
      memberName: "",
      date: null,
      time: null,
      notificationType: "sms",
      description: "",
      subject: "",
      body: "",
      title: "",
      pushDescription: "",
      language: "english",
    },
    validate: (values) => {
      const errors = {};
      if (!values?.productName && !values?.groupName && !values?.memberName) {
        errors.selection = "Please select at least one dropdown option";
      }
      return errors;
    },
    onSubmit: (value) => {
      const { productName, groupName, memberName } = value;
      const payload = {
        notificationReceiver: {
          userId: memberName
            ? userData
                .filter((user) => `${user?.caspioUserId}` === memberName)
                .map((user) => user?.userId)
            : undefined,
          productId: productName
            ? getProduct
                .filter((product) => product?.code === productName)
                .map((product) => product?.productId)
            : undefined,
          groupId: groupName
            ? groupsData
                .filter((group) => group?.caspioEmployerGroupCode === groupName)
                .map((group) => group?.groupCode)
            : undefined,
        },
        brandId: brandId,
      };
      dispatch(triggerWelcomeEmailHandler(payload));
      // formik.setFieldValue("productName", null);
      // formik.setFieldValue("groupName", null);
      // formik.setFieldValue("memberName", null);
      
    },
  });

  const showError =
    formik?.errors?.selection &&
    !formik?.values?.productName &&
    !formik?.values?.groupName &&
    !formik?.values?.memberName;

  return (
    <div className="rightside">
      {(getWelcomeEmailListSelector?.isLoading === true || triggerWelcomeSelector?.isLoading) && (
        <Loader loaderTransForm="loaderTransForm" />
      )}
      <div className="rightcontent">
        <p>
          <strong>Welcome Email Templates</strong>
        </p>
        
        <CustomBreadcrumb
          items={[
            { text: BreadCrum.HOME },
            { text: BreadCrum.EMAIL_TEMPLATE, active: true },
          ]}
        />
                  <form onSubmit={formik?.handleSubmit}>
        <div className="sectionpadding mb-30">
          <p className="mb-0 heedprodct">Send Welcome Email Notification</p>
          <hr />
          <div className="d-xxl-flex align-items-center mb-30">
            <div className="pe-xxl-2 me-xxl-2 selecttype selecttype">
              <p className="labelp">Product Name*</p>
              <SearchSelect
                value={formik?.values?.productName || "Search for Product"}
                options={getProduct
                  ?.filter(
                    (item) =>
                      item?.productStatus.toLowerCase() === "active" ||
                      item?.productStatus.toLowerCase() === "activestatus"
                  )
                  .map((data) => {
                    return {
                      value: data?.code,
                      label: data?.productName + " " + `(${data?.code})`,
                    };
                  })}
                onBlur={() => {}}
                onChange={(value) => {
                  formik.setFieldValue("productName", value);
                  formik.setTouched(false);
                  formik.setFieldValue("groupName", null);
                  formik.setFieldValue("memberName", null);
                }}
                onPopupScroll={handleProductScroll}
                id="productName"
                placeholder="Search for Product"
                // loading={productLoading}
                menuItemScrollable={true}
                listHeight={256}
                dropdownStyle={{ maxHeight: "256px" }}
                onDropdownVisibleChange={(open) => {
                  if (open && getProduct?.length === 0) {
                    handleProduct("");
                  }
                }}
                onSearch={handleProductSearch}
                loading={getAllProductList?.isLoading}
              />
              {showError && (
                <div className="error">{formik?.errors?.selection}</div>
              )}
            </div>
            <div className="pe-xxl-2 me-xxl-2">
              <p className="my-3 mt-xxl-5"> OR</p>
            </div>
            <div className="pe-xxl-2 me-xxl-2 selecttype selecttype">
              <p className="labelp">Select Group*</p>
              <SearchSelect
                value={formik?.values?.groupName || "Search for Group"}
                options={groupsData.map((data) => {
                  return {
                    value: data?.caspioEmployerGroupCode,
                    label:
                      data?.groupName +
                      " " +
                      `(${data?.caspioEmployerGroupCode})`,
                  };
                })}
                onBlur={() => {}}
                onChange={(value) => {
                  formik.setFieldValue("groupName", value);
                  formik.setTouched(false);
                  formik.setFieldValue("productName", null);
                  formik.setFieldValue("memberName", null);
                }}
                onPopupScroll={handleGroupScroll}
                id={"groupName"}
                placeholder="Search for Group"
                // loading={groupLoading}
                menuItemScrollable={true}
                listHeight={256}
                dropdownStyle={{ maxHeight: "256px" }}
                onDropdownVisibleChange={(open) => {
                  if (open && groupsData?.length === 0) {
                    handleGroup("");
                  }
                }}
                onSearch={handleGroupSearch}
                loading={getAllGroupsList?.isLoading}
              />
              {showError && (
                <div className="error">{formik?.errors?.selection}</div>
              )}
            </div>
            <div className="pe-xxl-2 me-xxl-2">
              <p className="my-3 mt-xxl-5"> OR</p>
            </div>
            <div className="pe-xxl-2 me-xxl-2 selecttype selecttype">
              <p className="labelp">Select Member*</p>
              <SearchSelect
                options={userData
                  .filter(
                    (item) =>
                      item?.memberStatus.toLowerCase() === "active" ||
                      item?.memberStatus.toLowerCase() === "activestatus"
                  )
                  ?.map((data) => {
                    return {
                      value: data?.caspioUserId,
                      label:
                        data?.firstName +
                        " " +
                        data?.lastName +
                        " " +
                        `(${data?.caspioUserId})`,
                    };
                  })}
                onBlur={() => {}}
                value={formik?.values?.memberName || "Select Member"}
                onChange={(value) => {
                  formik.setFieldValue("memberName", value);
                  formik.setTouched(false);
                  formik.setFieldValue("groupName", null);
                  formik.setFieldValue("productName", null);
                }}
                onPopupScroll={handleMemberScroll}
                id={"memberName"}
                placeholder="Select Member"
                // loading={memberLoading}
                menuItemScrollable={true}
                listHeight={256}
                dropdownStyle={{ maxHeight: "256px" }}
                onDropdownVisibleChange={(open) => {
                  if (open && userData?.length === 0) {
                    handleMemberName("");
                  }
                }}
                onSearch={handleMemberSearch}
                loading={getUserList?.isLoading}
              />
              {showError && (
                <div className="error">{formik?.errors?.selection}</div>
              )}
            </div>
          </div>
          <div className="text-end bgt">
              <button
                type="submit"
                className="sbg border-0 py3 fw-18 gbo continuebtn savebtn"
              >
                Send
              </button>
            </div>
        </div>
        </form>
        <div className="table-padding">
          <div className="headtitle">
            <p className="mb-0 heedprodct">Welcome Email Templates</p>
            <div className="flex gap-3 justify-end align-center mx420">
               <CommanSearchBox
                 value={searchValue}
                 setValue={setSearchValue}
                 getSearchValue={handleTemplateListData}
              />
            <Link className="primarybtn h-fit" to="/manage-email-template">
              <div className="plus"></div>
              Create
            </Link>
            </div>
          </div>
          <hr className="m-0" />
          <div className="table-responsive">
            <CommonTable
            handlePageChange={handleTemplateListData}
              pagination={pagination}
              body={emailListData}
              columns={emailColumnsData}
            />
          </div>
          <SwitchModal
            show={switchModalOpen}
            onYes={handleSwitchModalYes}
            onNo={handleSwitchModalNo}
          />
          <SwitchModal
            show={warningModalOpen}
            onYes={handleWarningModalOkay}
            onNo={handleWarningModalOkay}
            onOkOnly={true}
            title={warningTitle}
            message={warningMessage}
          />
        </div>
      </div>
    </div>
  );
};

export default EmailTemplatesList;
